import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchWithAuth } from '../authFetcher'
import { useAuthStatus } from '../routes/useAuthStatus'

/**
 * Custom hook that provides the fetchWithAuth function and automatically
 * redirects to the session-expired route when a session becomes invalid.
 *
 * @returns {Function} The fetchWithAuth function
 */
export const useFetchWithAuth = () => {
  const navigate = useNavigate()
  const { invalidSession } = useAuthStatus()

  // Handle session invalidation by redirecting to session-expired
  useEffect(() => {
    if (invalidSession) {
      navigate('/session-expired', { replace: true })
    }
  }, [invalidSession, navigate])

  // Return the fetchWithAuth function
  return useCallback((url: string, options: RequestInit = {}) => {
    return fetchWithAuth(url, options)
  }, [])
}
